import { render, staticRenderFns } from "./OnEventOverlay.vue?vue&type=template&id=00622c1c&"
import script from "./OnEventOverlay.vue?vue&type=script&lang=js&"
export * from "./OnEventOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports